<template>
	<div
		class="rounded-xl px-4 lg:px-4 pt-2 pb-4 lg:pb-4 shadow bg-white ring-orange-500"
	>
		<div ref="chart" style="width: 300px; height: 300px"></div>
	</div>
</template>

<script>
import * as echarts from "echarts";

let matif = require("./sample-data.json");
export default {
	props: {
		contracts: {
			type: Array,
			required: true,
		},
		filter: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			matif: matif,
		};
	},
};
</script>
